import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { Icon } from "antd";
import { ReactComponent as CheckSvg } from "../../assets/icon/ic_check_24dp.svg";
import "./FlagSelector.scss";

const activeIcon = <Icon className="active-icon" component={CheckSvg} />;

function FlagBox({
  visible,
  isFlagSelected,
  onFlagSelect,
  setFlagRef,
  flags,
  formatMessage,
}) {
  const chatConfig = window.Social.getChatConfig();
  const flagsInstances = flags;

  if (!visible) {
    return false;
  }
  let flagsSpan = flagsInstances.map((elem) => {
    return (
      <span
        className="flag"
        key={elem.id}
        onClick={() => onFlagSelect(elem.id)}
      >
        <span className="flag-color" style={{ backgroundColor: elem.color }} />
        {elem.flagName}
        {isFlagSelected(elem.id) && activeIcon}
      </span>
    );
  });
  return (
    <div className="flags-box-container" ref={(node) => setFlagRef(node)}>
      <span className="flags-title"> {formatMessage({ id: "chat.flag" })}</span>
      {flagsSpan}
      <span className="flag" onClick={() => onFlagSelect(null)}>
        {formatMessage({ id: chatConfig.emptyFlag })}
        {isFlagSelected(null) && activeIcon}
      </span>
    </div>
  );
}

class FlagSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flagsOpen: false,
      selectedFlag: null,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  toggleFlags(e) {
    e.stopPropagation();
    this.setState(
      {
        flagsOpen: true,
      },
      document.addEventListener("click", this.handleClickOutside)
    );
  }

  onFlagSelect(value) {
    this.setState(
      {
        selectedFlag: value,
      },
      () => this.props.onFlagSelect(value)
    );
  }

  isFlagSelected(value) {
    return this.state.selectedFlag === value;
  }

  getFlagName() {
    const { formatMessage } = this.props.intl;
    const flag = this.props.flags.find(
      (elem) => elem.id === this.state.selectedFlag
    );
    return this.state.selectedFlag && flag
      ? flag.flagName
      : formatMessage({ id: "chat.noFlag" });
  }

  getMakerStyle() {
    const flag = this.props.flags.find(
      (elem) => elem.id === this.state.selectedFlag
    );
    return this.state.selectedFlag && flag
      ? {
          backgroundColor: flag.color,
          color: "rgba(0, 0, 0, 0.45)",
          border: "none",
        }
      : {};
  }

  handleClickOutside(event) {
    if (
      this.flagRef &&
      !this.flagRef.contains(event.target) &&
      event.target !== null
    ) {
      event.stopPropagation();
      this.setState(
        {
          flagsOpen: false,
        },
        document.removeEventListener("click", this.handleClickOutside)
      );
    }
  }

  setFlagRef(node) {
    this.flagRef = node;
  }

  canShowFlagsSelector() {
    return this.state.flagsOpen;
  }

  render() {
    return (
      <div className="flag-selector">
        <span
          className="message-input-flag"
          style={this.getMakerStyle()}
          onClick={this.toggleFlags.bind(this)}
        >
          {this.getFlagName()}
        </span>
        <FlagBox
          flags={this.props.flags}
          formatMessage={this.props.intl.formatMessage}
          visible={this.canShowFlagsSelector.bind(this)()}
          setFlagRef={this.setFlagRef.bind(this)}
          isFlagSelected={this.isFlagSelected.bind(this)}
          onFlagSelect={this.onFlagSelect.bind(this)}
        />
      </div>
    );
  }
}

export default injectIntl(FlagSelector);
